﻿import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
	selector: 'form-case-send-administrator',
	templateUrl: './form-case-send-administrator.component.html',
	styleUrls: ['./form-case-send-administrator.component.scss']
})
export class FormCaseSendAdministratorComponent implements OnInit {

  @Output()
  callbackRegister = new EventEmitter();
  @Input()
  data: any;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    this.data.sentAdministratorDate = this.data.sentAdministratorDate || new Date();

    this.callbackRegister.emit({
      isValid: this.isValid,
    });
  }

  isValid() {
    return !!this.data.sentAdministratorDate;
  }
}
